import type {RootState} from '../../../store';
import type {ISelectionSlice} from '../../../store/types';

/**
 * Reads the customers selection slice (FNP-951).
 *
 * Kept as a named selector rather than an inline arrow at each call site so the
 * `customers.selection` path is written once — the path is a string key that
 * the compiler checks only here.
 */
export const selectionSelector = (state: RootState): ISelectionSlice =>
    state.customers.selection;
